var React = require('react');

function NoticeIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M82.5002 1.86847e-10C60.6198 -4.65324e-05 39.6356 8.69185 24.1638 24.1636C8.69204 39.6353 5.15906e-05 60.6195 1.90619e-10 82.4998C-2.32909e-05 93.3339 2.13389 104.062 6.27991 114.071C10.4259 124.081 16.5028 133.175 24.1637 140.836C31.8245 148.497 40.9193 154.574 50.9287 158.72C60.9381 162.866 71.6661 165 82.5002 165C104.381 165 125.365 156.308 140.836 140.836C156.308 125.364 165 104.38 165 82.4998C165 60.6195 156.308 39.6354 140.836 24.1637C125.365 8.69199 104.38 5.20962e-05 82.5002 1.86847e-10V1.86847e-10ZM70.1839 25.0252H94.8161L89.2703 104.52H76.0899L70.1839 25.0252ZM70.9761 115.172H93.9516V139.975H70.9761V115.172Z","fill":"#1682C9"}));
}

NoticeIconInline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 165 165","fill":"none"};

module.exports = NoticeIconInline;

NoticeIconInline.default = NoticeIconInline;
